import * as d3 from 'd3';
import React, { useEffect } from 'react';
import havana from '../../../../../data/havana'

function Genome (props) {
    
    const dataset = props.dataset,
        biobanks = props.biobanks,
        types = props.types,
        dna = props.dna || [],
        pos = props.pos,
        settings = props.settings,
        topView = props.topView,
        setTopView = props.setTopView,
        ranges = props.ranges,
        size = props.size,
        resolution = props.resolution,
        defineMinPval = props.defineMinPval,
        drawLines = props.drawLines;
    
    const roundedDNA = getRoundedDNA(resolution);

    function getRoundedDNA (resolution) {
        const slot = Math.ceil(d3.sum(dna, d=>d.size)/resolution),
            roundedDNA = dna.map(item => {return({...item, slots: Math.ceil(item.size/slot)})});
        return roundedDNA
    }

    function getLayout (dna, format) {
        var layout = []
        dna.forEach((chromosome, chrN) => {
            const cutDNA = roundedDNA.slice(0, chrN),
                slots = d3.sum(cutDNA, d => d.slots),
                start = slots*format.width + chrN*size.margin.gutter + size.margin.left,
                end = start + dna[chrN].slots*format.width
            layout.push([start, end])
        })
        return layout
    }

    function getFormat (resolution) {
        const capacity = Math.ceil(d3.sum(dna, d=>d.size)/resolution),
            number = d3.sum(roundedDNA, d => d.slots),
            width = (size.width - size.margin.left - size.margin.gutter*22) / number;

        const format = {
            size: capacity,
            number: number,
            width: width
        };
        return format
    };

    function drawLayers(biobanks){
        d3.select('#thumbnail01')
            .selectAll('.layer')
            .data(biobanks)
            .join('g')
                .attr('class', 'layer')
                .attr('id', (d,i) => `layer01_${i}`)
                .style('transform', (d,i) => `translateY(${(i*size.height + size.margin.top)}px)`)
                .on('mouseenter', (e,d) => d3.select('#chart_BB_'+biobanks.indexOf(d)).style('fill', settings.pink1))
                .on('mouseleave', (e,d) => d3.select('#chart_BB_'+biobanks.indexOf(d)).style('fill', settings.blue3))
                .selectAll('.chromosome')
                .data([...Array(23).keys()])
                .join('g')
                    .attr('class', 'chromosome')
                    .style('cursor', 'pointer')
                    .style("transform",`translateX(50px)`)
                    .attr('id', function(d){
                        const bbN = d3.select(this.parentNode).attr('id').replace('layer01_','')
                        return 'bb'+bbN+'_chr'+d
                    })
                    .on('mouseenter', function(e,d,i) {
                        if (topView[1] === 'gnm') {
                            d3.select('#line_chr'+(d+1)).classed('lineHovered', true)
                            d3.selectAll('.chromosome').classed('chrHovered', false)
                            biobanks.forEach((bb,n) => d3.select('#bb'+n+'_chr'+d).classed('chrHovered', true))
                        }
                    })
                    .on('mouseleave', () => {
                        d3.selectAll('.lineHovered').classed('lineHovered', false)
                        d3.selectAll('.chromosome').classed('chrHovered', false)
                    })
                    .on('click', (e,d) => {
                        topView[1] === 'gnm' && setTopView(['cht', 'chr', d])
                    });

    }

    function drawThumbnail (data, format, layout) {
        biobanks.forEach((biobank, bbN)=>{

            const logRanges = ranges[bbN],
                intRanges = logRanges.map(item => {return 10**item});
            
            const scalePvalueToShade = d3.scaleThreshold().domain(intRanges).range(settings.colors.pvalue),
                scaleNominalToShade = d3.scaleThreshold().domain(intRanges).range(settings.colors.nominal);

            function colorRects (datum, type) {
                if (type === 'pvalue') {
                    if (datum === undefined) return settings.blue0
                    else return scalePvalueToShade(datum)
                } else if (type === 'nominal') {
                    if (datum === undefined) return settings.gray1
                    else return scaleNominalToShade(datum)
                }
            }

            data.forEach((chromosome, chrN) => {
                
                function getSlots(){
                    const chrUI = chromosome[1].map(d=>{
                        d[pos] = parseInt(d[pos]);
                        d[biobank] = parseFloat(d[biobank]);
                        return d;
                    })
                    
                    let slots = [];
                    let slotsNumber = roundedDNA[chrN].slots;
                    
                    for (let i = 0; i < slotsNumber; i++) {
                        slots.push({
                            bb: bbN,
                            chr: chrN, 
                            slot: i,
                            low: format.size*[i],
                            high: format.size*[i+1],
                            elements: [],
                    })}
    
                    if (chrUI.length !== 0) {
                        let current = 0;
    
                        function recursiveCheck(e){
                            if (e[pos] >= slots[current].high) {
                                current++;
                                recursiveCheck(e);
                            }
                        };
                        
                        chrUI.forEach(e => {
                            recursiveCheck(e)
                            slots[current].elements.push(e)
                        })
                    }
                    slots = slots.map(item => {return {...item, value: defineMinPval(item.elements, biobank)}})
                    return slots
                }
                
                const slots = getSlots()
                
                d3.select('#bb'+bbN+'_chr'+chrN)
                    .style("transform",`translateX(${layout[chrN][0]-size.margin.left}px)`)
                    .selectAll(".unit")
                    .data(slots)
                    .join("rect")
                        .classed("unit", true)
                        .attr('y', 0.5)
                        .attr('width', format.width)
                        .attr('height', size.height-1)
                        .on('mouseover', () => d3.select('#hoverLine01').style('display', 'none'))
                        .on('click', ()=>{})
                        .transition().duration(500)
                            .attr('x', d => format.width * d.slot + size.margin.left)
                            .attr('fill', d => colorRects(d.value, types[bbN]))

                d3.selectAll('.unit').each(function(){if (!d3.select(this.parentNode).classed('chromosome')) {d3.select(this).remove()}})
            })
        })
    }

    

    useEffect(()=>{

        if (topView[1] === 'gnm') {

            const format = getFormat(resolution),
                layout = getLayout(roundedDNA, format);

            drawLayers(biobanks)
            drawLines(layout)
            drawThumbnail(dataset, format, layout)

        }
    })

    return(
        <></>
        )
    
}
export default Genome;